import { Box, Grid } from '@mui/material';
import SignpostIcon from '@mui/icons-material/Signpost';
import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly';
import BusinessIcon from '@mui/icons-material/Business';
import MobileScreenShareIcon from '@mui/icons-material/MobileScreenShare';
import FaxIcon from '@mui/icons-material/Fax';
import WifiCallingIcon from '@mui/icons-material/WifiCalling';
import ApartmentIcon from '@mui/icons-material/Apartment';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import Params from '../../../Types/ParamsPicklist';

let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchPays: Params = { CodeAgence: '', Table: "CDPAYS", Colonne1: "CDPAYS", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchVille: Params = { CodeAgence: '', Table: "CdVille", Colonne1: "CdVille", Colonne2: "Libell", Colagence: '001', Choix: 22 }


const Tab2 = (props: { form?: any }) => {

  return (

    <div className='tabItem'>
      <div >
        <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
          <Grid item xs={12} className='border-left'>
            <Grid container>
              <Grid item xs={12} md={6} className='border-left'>
                <SearInputM width={7} Titre='Recherche Type Adresse' label='Type Adresse' name="TYPADR" Parametre={searchTypAdr} form={props.form} />
                <InputForm notRequired icon={<SignpostIcon  color='action' />} width={7} label='Numéro Rue' name='rueCli' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={7}   icon={<MobileFriendlyIcon color='action'/>} widthl={0} label='Téléphone Mobile 1' RegExp={/[0-9]{9}$/gmi} MessExp='le numéro doit étre de 9 chiffres' name='telCli' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={7}   icon={<MobileScreenShareIcon  color='action' />} label='Téléphone Mobile 2' RegExp={/[0-9]{9}$/gmi} MessExp='le numéro doit étre de 9 chiffres' name='Tel2' type='number' error=' ce Champ est obligatiore' />
                <InputForm notRequired  icon={<BusinessIcon  color='action' />} width={7} label='Adresse postale' name='adrPostal' type='text' error=' ce Champ est obligatiore' />
                <SearInputM width={7} Titre='Recherche Pays' label='Pays' name='CDERES' Parametre={searchPays} form={props.form} />
              </Grid>
              <Grid item xs={12} md={6} className='border-left'>
                <SearInputM width={7} Titre='Recherche Ville' label='Ville' name='vilCli' Parametre={searchVille} form={props.form} />
                <InputForm notRequired icon={<WifiCallingIcon color='action' />} width={7} label='Telex' name='Telex' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={7}   icon={<ReduceCapacityIcon color='action' />} label='Quatier' name='nomQtier' type='text' error=' ce Champ est obligatiore' />
                <InputForm width={7}   icon={<ApartmentIcon  color='action'/>} label='Boite Postale' name='BpCli' type='text' />
                <InputForm notRequired icon={<AttachEmailIcon color='action'/> } width={7} label='Adresse Email' name='emailctt1' type='email' error=' ce Champ est obligatiore' />
                <InputForm icon={<FaxIcon color='action'/>} width={7} label='Fax' name='FaxCli' type='text' error=' ce Champ est obligatiore' />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>

  );

}

export default Tab2;